<template>
    <div class="navigation">
        <div class="header-inner">
        <el-row type="flex" align="top">
            <el-col :span="2"><div class="grid-content"></div></el-col>

            <el-col :span="6">
                <div class="logo">
                    <img src="../assets/logo.png.webp">
                </div>
                <div class="title">
<!--                    <p class="name">GONG Qing</p>-->

                    <p class="info">{{ language === 'zh' ? '龚卿 Ph.D.，浙江大学' : '龚卿 Ph.D., Zhejiang University' }}</p>
                </div>
            </el-col>
            <el-col :span="2">

            </el-col>
            <el-col :span="12" class="nav-menu-col">
                <div class="header-nav-cluster">
                    <el-menu
                        :default-active="activeIndex"
                        class="header-menu"
                        mode="horizontal"
                        text-color="#999"
                        active-text-color="#000"
                    >
                        <el-menu-item class="header-menu-item" index="1">
                            <a href="#/" class="navigation-text"><span class="navigation-text-text">{{ language === 'zh' ? '研究 / 项目' : 'RESEARCH / PROJECTS' }}</span></a>
                        </el-menu-item>
                        <el-menu-item class="header-menu-item" index="2">
                            <a href="#/about" class="navigation-text"><span class="navigation-text-text">{{ language === 'zh' ? '关于' : 'ABOUT' }}</span></a>
                        </el-menu-item>
                        <el-menu-item class="header-menu-item" index="3">
                            <a href="#/cv" class="navigation-text"><span class="navigation-text-text">{{ language === 'zh' ? '简历' : 'CV' }}</span></a>
                        </el-menu-item>
                        <el-menu-item class="header-menu-item" index="4">
                            <a href="#/media" class="navigation-text"><span class="navigation-text-text">{{ language === 'zh' ? '媒体' : 'MEDIA' }}</span></a>
                        </el-menu-item>
                    </el-menu>
                    <div class="lang-switch">
                        <span
                            class="lang-option"
                            :class="{ active: language === 'zh' }"
                            role="button"
                            tabindex="0"
                            @click="setLanguage('zh')"
                            @keydown.enter.prevent="setLanguage('zh')"
                        >中文</span>
                        <span class="lang-sep" aria-hidden="true">|</span>
                        <span
                            class="lang-option"
                            :class="{ active: language === 'en' }"
                            role="button"
                            tabindex="0"
                            @click="setLanguage('en')"
                            @keydown.enter.prevent="setLanguage('en')"
                        >English</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Header",
        props: {
            language: {
                type: String,
                default: 'zh'
            }
        },
        data() {
            return {
                activeIndex: '1',
            };
        },
        methods: {
            setLanguage(lang) {
                this.$emit('language-change', lang);
            }
        }
    }
</script>

<style scoped>

    .logo{

    }
    .logo img{
        width: 20vw;

    }
    .nav-menu-col{
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
    }
    .header-nav-cluster{
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
        flex-wrap: nowrap;
        width: 100%;
        box-sizing: border-box;
        margin-top: 40px;
        gap: 24px;
    }
    .header-menu{
        border: none !important;
        flex: 0 1 auto;
        min-width: 0;
        margin-top: 40px;
        margin-right: 120px;
        background: transparent !important;
        display: flex !important;
        justify-content: flex-end;
        flex-wrap: wrap;
        align-items: flex-start;
    }
    .header-menu >>> .el-menu--horizontal{
        border-bottom: none !important;
        padding-top: 0 !important;
    }
    .header-menu >>> .el-menu--horizontal > .el-menu-item{
        font-size: 13px !important;
        display: inline-flex !important;
        align-items: flex-start !important;
    }
    .header-menu >>> .el-menu--horizontal > .el-menu-item:hover{
        background-color: transparent !important;
        border-bottom: none !important;
    }
    .header-menu-item{
        margin: 0 !important;
    }
    .navigation-text-text{
        margin: 0;
        padding: 0;
        text-align: center;
        display: inline-block;
        vertical-align: top;
        font-size: 13px;
        letter-spacing: 0.5px;
        line-height: 1.35;
    }
    .name{
        font-size: 40px;
        font-weight: 900;
        letter-spacing: 3px;
        z-index:999;
    }
    .info{
        color: #aaa;
        font-weight: 200;
        font-size:15px;
        margin-top:-40px;
        letter-spacing:1px;
        z-index:999;
    }
    .title{
        min-height: 36px;
        border:none;
        margin-top: 40px;
        z-index:999;
    }
    .lang-switch{
        flex: 0 0 auto;
        margin: 40px 0 0 0;
        padding: 0;
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        gap: 8px;
        font-size: 13px;
        line-height: 1.35;
        height: auto;
        letter-spacing: 0.5px;
        user-select: none;
    }
    .lang-option{
        cursor: pointer;
        color: #999;
        transition: color 0.2s ease, font-weight 0.2s ease;
    }
    .lang-option:hover{
        color: #666;
    }
    .lang-option.active{
        color: #000;
        font-weight: 500;
    }
    .lang-sep{
        color: #ccc;
        cursor: default;
    }
    .navigation-text {
        text-decoration: none;
        font-size: 13px;
        letter-spacing: 0.5px;
    }
    .header-inner {
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        box-sizing: border-box;
    }
    .navigation {
        margin-top: 80px;
    }
    .grid-content {
        min-height: 36px;
        border: none;
    }
</style>

<!-- Element UI 横向菜单默认 height:60px + 底部 border，导致文字与线距离很大；需盖过 node_modules 里的选择器 -->
<style>
    .navigation .el-menu.header-menu.el-menu--horizontal > .el-menu-item {
        position: relative;
        float: left;
        height: auto !important;
        min-height: 0 !important;
        line-height: 1.35 !important;
        border-bottom: none !important;
        padding: 0 18px 2px !important;
    }
    .navigation .el-menu.header-menu.el-menu--horizontal > .el-menu-item.is-active {
        border-bottom: none !important;
    }
    .navigation .el-menu.header-menu.el-menu--horizontal > .el-menu-item.is-active .navigation-text-text {
        border-bottom: 2px solid #000;
        padding-bottom: 8px;
    }
</style>